<template>
  <div class="league">
    <v-container class="pt-0">
      <span class="headline">{{$t('dashboard.title')}}</span>
      <v-row>
        <v-col
          cols="12" md="6"
          v-if="$store.state.friendshipRequests.length > 0"
        >
          <alert :text="$tc('friendshipRequest.incoming', $store.state.friendshipRequests.length, {n: $store.state.friendshipRequests.length})" :type="'info'" :link="'/friendshipRequests'"/>
        </v-col>
        <v-col
          cols="12" md="6"
          v-if="$store.state.gameInvitations && $store.state.gameInvitations.length > 0"
        >
          <alert :text="$tc('competitionInvitation.incoming', $store.state.gameInvitations.length, {n: $store.state.gameInvitations.length})" :type="'info'" :link="'/gameInvitations'"/>
        </v-col>
        <v-col
          cols="12"
          v-if="false"
        >Du nimmst aktuell an {{$store.state.activeGames.length}} Wettkämpfen teil.</v-col>
      </v-row>
      <v-row v-if="$store.state.env.global.listPublicCompetitions === true">
        <v-col cols="12">
          <span class="overline">{{$t('dashboard.public-competitions')}}</span>
          <public-games-table></public-games-table>
        </v-col>
      </v-row>
      <v-row v-if="true || activeGames.length > 0">
        <v-col cols="12">
          <span class="overline">{{$t('dashboard.active-competitions')}}</span>
          <game-list :games="activeGames"></game-list>
        </v-col>
      </v-row>
      <v-row v-if="true || preparedGames.length > 0">
        <v-col cols="12">
          <span class="overline">{{$t('dashboard.competitions-in-preparation')}}</span>
          <game-list :games="preparedGames"></game-list>
        </v-col>
      </v-row>
      <v-row v-if="canCreateNewGames">
        <v-col>
          <v-btn to="/game/new" class="primary">
            <v-icon left>mdi-soccer-field</v-icon>{{$t('createGame.title')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="$store.state.env.global.listPublicCompetitions === true">
        <v-col>
          <v-btn to="/competitions/public" class="secondary">
            <v-icon left>mdi-earth</v-icon>{{$t('publicGames.title')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn to="/gamehistory" class="">
            <v-icon left>mdi-history</v-icon>{{$t('gameHistory.title')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="checkNewAppVersion" :disabled="$store.state.isLoading">
            <v-icon left>mdi-reload</v-icon>{{$t('app.check-update')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";

import GameList from "@/widgets/GameList";
import Alert from "@/widgets/Alert";

import envMixin from "@/mixins/envMixin";
import PublicGamesTable from '../widgets/PublicGamesTable'

export default {
  name: "Dashboard",
  components: { PublicGamesTable, GameList, Alert },
  mixins: [ envMixin ],

  data: () => ({}),

  computed: {
    preparedGames() {
      return this.$store.state.activeGames.filter(game => {
        return game.state == "created";
      });
    },
    activeGames() {
      return this.$store.state.activeGames.filter(game => {
        return game.state == "active" || game.state == "checkin" || game.state == "checkinDone";
      });
    },
    canCreateNewGames() {
      return this.envGetUserKey('permission.createGames') == true;
    },
  },
  mounted() {
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  methods: {
    onRefreshData() {
      // nothing todo here currently
    },
    checkNewAppVersion() {
      window.location.reload();
    },
  }
};
</script>
